// extracted by mini-css-extract-plugin
export default {"button":"Password_button__h1hMX","buttons":"Password_buttons__zmwc3"};